module.exports = __webpack_public_path__ + "img/onboarding_waiting_compute_race.1b9f5b72.gif";